import { FETCH_MEMBER_SYNDICATES_SUCCESS } from 'constants/syndicate';

const memberSyndicates = (state = [], action) => {
  switch (action.type) {
    case FETCH_MEMBER_SYNDICATES_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

export default memberSyndicates;



// WEBPACK FOOTER //
// ./src/reducers/memberSyndicates.js